import {SODeleteWork} from '../../core/work/so-delete-work';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteWork extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteWork;
}